var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-cards',{attrs:{"events":_vm.events,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }